import { NavLink } from "react-router-dom";
import Page from "./Page";

export default function NotFound() {
  return (
    <Page>
      <div className="not-found-container">
        <div className="page-header">
          <h1 className="titleFont">Page not found</h1>
          <p className="lead">The page you’re looking for doesn’t exist.</p>
          <NavLink to="/" className="main-nav link">
            Go back home
          </NavLink>
        </div>
      </div>
    </Page>
  );
}
